document.addEventListener('alpine:init', () => {
  Alpine.data('accordionItem', (open = false) => ({
    open,
    toggle() {
      this.open = !this.open;
      if (this.open) {
        this.$nextTick(() => {
          this.$dispatch('accordion:open', { id: this.$id('accordion') });
        });
      }
    },
    close() { this.open = false },
    init() {
      if (this.open) {
        this.$nextTick(() => {
          this.$dispatch('accordion:open', { id: this.$id('accordion') });
        });
      }
    }
  }));
});
